<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ isAssolement ? 'Mes cultures ' + campagne : 'Sélectionnez vos cultures' }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <v-ons-list v-for="indexList in [0, 1]" :key="indexList" :modifier="! indexList ? 'noborder perflist' : 'noborder perflistcult'">

        <v-ons-list-item v-for="(culture, indexCult) in culturesList" v-if="(! indexList && indexCult < 3) || (indexList && indexCult >= 3)"
                         :key="culture.refCulture + '-' + culture.refDestination" modifier="perfcult" tappable @click="toggleCheckbox(indexCult)">

          <div class="left">
            <span class="list-item__thumbnail"
                  :style="{'background-image': $getCultAsset(culture.refCulture, culture.refDestination, 'icon')}" />
          </div>

          <div class="center">
            <span class="list-item__title">
              {{ culture.label }}
              <img v-if="culture.isBio" src="../assets/imgs/bio_carre@2x.png">
            </span>
          </div>

          <div class="right">
            <v-ons-checkbox modifier="material" :value="indexCult" v-model="cultCheckboxList" :disabled="culture.isDisabled"></v-ons-checkbox>
          </div>

        </v-ons-list-item>

        <!--
        <v-ons-list-item v-if="indexList" modifier="perfbutton">
          <v-ons-button modifier="quiet" @click="newCulture">
            Ajouter une autre culture
          </v-ons-button>
        </v-ons-list-item>
        -->

      </v-ons-list>

    </div>

    <v-ons-bottom-toolbar v-if="cultCheckboxList.length" modifier="cta background">
      <div v-if="isAssolement && cultCheckboxList.length == 1">
        Ajouter d'autres cultures,<br />
        ou <a href="#" @click="addCulture">Valider</a>
        &nbsp;<v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </div>
      <v-ons-button v-else modifier="large--cta perflarge" @click="addCulture">
        Valider mes cultures
        <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </v-ons-button>
    </v-ons-bottom-toolbar>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppCultureFiche from './CultureFiche.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  props: ['pageStack'],
  data() {
    return {
      isAssolement: false,
      cultCheckboxList: [],
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    referentiel() {
      return this.data.referentiel;
    },
    culturesList() {
      var cultNegoce = {};
      var negoce = this.getNegoceAcces(this.data.negoce.list);
      for (let i = 0; i < negoce.length; i++) {
        var negoceItem = negoce[i];
        for (const campagne in negoceItem.prix) {
          var campagneItem = negoceItem.prix[campagne];
          for (const refCult in campagneItem) {
            if (!cultNegoce[refCult]) {
              cultNegoce[refCult] = [];
            }
            for (const refDest in campagneItem[refCult]) {
              cultNegoce[refCult].push(refDest);
            }
          }
        }
      }
      var cultUser = {};
      for (let i = 0; i < this.user.cultures.length; i++) {
        const cult = this.user.cultures[i];
        if (!cultUser[cult.ref_culture]) {
          cultUser[cult.ref_culture] = [];
        }
        cultUser[cult.ref_culture].push(cult.ref_destination);
      }
      var list = [];
      for (const refCult in this.referentiel.cultures) {
        const cult = this.referentiel.cultures[refCult];
        for (const refDest in cult.destinations) {
          const dest = cult.destinations[refDest];
          if (dest.is_principal || (cultNegoce[refCult] && cultNegoce[refCult].includes(refDest))) {
            var isDisabled = cultUser[refCult] && cultUser[refCult].includes(refDest);
            list.push({
              refCulture: refCult,
              refDestination: refDest,
              label: this.getCultLabel(refCult, refDest),
              isBio: cult.is_bio,
              isDisabled: isDisabled,
            });
          }
        }
      }
      this.sortCultList(list);
      for (let i = 0; i < list.length; i++) {
        const cult = list[i];
        if(cult.isDisabled && ! this.cultCheckboxList.includes(i.toString())){
          this.cultCheckboxList.push(i.toString());
        }
      }
      return list;
    }
  },
  methods: {
    toggleCheckbox(indexCult) {
      indexCult = indexCult.toString();
      if (! this.cultCheckboxList.includes(indexCult)) {
        this.cultCheckboxList.push(indexCult);
      } else {
        this.cultCheckboxList.splice(this.cultCheckboxList.indexOf(indexCult), 1);
      }
    },
    newCulture() {
      this.pageStack.push({
        extends: AppCultureFiche,
        data() {
          return {
            indexCulture: -1
          }
        },
        onsNavigatorOptions: {
          animation: 'lift'
        }
      });
    },
    async addCulture() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        data: []
      };
      for (let i = 0; i < this.cultCheckboxList.length; i++) {
        const cultIndex = this.cultCheckboxList[i];
        if(this.culturesList[cultIndex].isDisabled){
          continue;
        }
        body.data.push({
          ref_culture: this.culturesList[cultIndex].refCulture,
          ref_destination: this.culturesList[cultIndex].refDestination
        });
      }
      if(! body.data.length){
        this.pageStack.length > 1 && this.pageStack.pop();
        return;
      }

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/culture/liste');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);
        
        this.pageStack.length > 1 && this.pageStack.pop();
      } catch(error) {
          this.handleError(error);
      }
    }
  }
}
</script>

<style>
.list--perflistcult {
  margin-bottom: 90px;
}
.bottom-bar.bottom-bar--background {
  background-color: var(--perfarmer-gris-bleu-light);
}
</style>